/**
 * "Report a problem" in the top bar, every skin (Dr. John, 2026-10-28: the
 * form must be one click away on every page). A plain icon button next to
 * the bell; a light bulb (Zac, 2026-10-28). It opens the same form as the user menu item, with this page's
 * context. Hidden at phone width, where the top bar overflows: the user menu
 * item is there instead.
 */
import { Lightbulb } from 'lucide-react';
import { useOptionalSession } from '../../app/shell.js';
import { openFeedback, useFeedbackUi } from './store.js';
import './feedback.css';

export function FeedbackButton() {
  const session = useOptionalSession();
  const { requestOpen } = useFeedbackUi();
  if (session === null || session === undefined) return null;
  return (
    <button
      type="button"
      className="shell-iconbtn fbk-topbtn"
      aria-label="Report a problem or suggest a feature"
      aria-haspopup="dialog"
      aria-expanded={requestOpen}
      title="Report a problem or suggest a feature"
      onClick={() => openFeedback()}
    >
      <Lightbulb size={16} aria-hidden />
    </button>
  );
}
